export default __webpack_public_path__ + "static/media/switchMode.e1298c6f.svg";